import Path from "./Path";
import { useTreeStateContext } from "../../contexts/TreeContext";
import { useEditorStateContext } from "../../contexts/EditorContext";
import "./PathContainer.css";

// Components who will display all the path who need to be display
function PathContainer() {

    const { pathsVisible } = useTreeStateContext();

    const { pathTmp } = useEditorStateContext();

    return (
        <svg className="svgs_container" style={{overflow : "visible"}}>
            <path id="path_tmp" style={{opacity : pathTmp ? 1 : 0}} fill="none" strokeWidth="2px" strokeDasharray="10,10"></path>
            {pathsVisible && pathsVisible.map(path => <Path key={path.path_id} {...path}/>)}
        </svg>
    )
}

export default PathContainer;